"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Breadcrumb_1 = __importDefault(require("../Breadcrumb"));
function PageHeader({ title, children, breadCrumbConfigs, }) {
    return (react_1.default.createElement("section", null,
        react_1.default.createElement("div", { className: "bg-info", style: { padding: "6px 28px", color: "#fff" } },
            react_1.default.createElement(react_bootstrap_1.Stack, { direction: "horizontal", gap: 3, className: "justify-content-between" },
                react_1.default.createElement("h1", { className: "text-nowrap", style: {
                        fontSize: "20px",
                        color: "#fff",
                        fontWeight: 700,
                    } }, title),
                children)),
        breadCrumbConfigs && react_1.default.createElement(Breadcrumb_1.default, { configs: breadCrumbConfigs })));
}
exports.default = PageHeader;
